import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';

import { LangProvider } from './i18n/LangContext';
import LoadingScreen from './components/LoadingScreen';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Divisions from './components/Divisions';
import Projects from './components/Projects';
import Industries from './components/Industries';
import Workforce from './components/Workforce';
import WhyAlpha7 from './components/WhyAlpha7';
import Community from './components/Community';
import Gallery from './components/Gallery';
import Partner from './components/Partner';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ChatAssistant from './components/ChatAssistant';
import Privacy from './components/Privacy';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);
  return null;
}

function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Divisions />
      <Projects />
      <Industries />
      <Workforce />
      <Gallery />
      <WhyAlpha7 />
      <Community />
      <Partner />
      <Contact />
    </>
  );
}

export default function App() {
  return (
    <LangProvider>
      <div className="App">
        <BrowserRouter>
          <LoadingScreen />
          <Navbar />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
          <Footer />
          <ChatAssistant />
        </BrowserRouter>
      </div>
    </LangProvider>
  );
}
